export default "__VITE_ASSET__D4UvGuR6__"